/** Lazily loads file-saver and triggers a download. */
export async function saveFile(data: Blob | string, fileName: string): Promise<void> {
  const { default: saveAs } = await import('file-saver');
  saveAs(data, fileName);
}
